import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../core/apis";
import { useLoadUsersInPlan } from "../../core/hooks/useLoadUsersInPlan";
import { useStores } from "../../core/stores";
import { useUserSelectForPlan } from "../../plans/PlanScreen";
import { FullScreenLoading } from "../../ui/Loading";
import { Screen } from "../../ui/Screen";
import { ModuleUIRenderer } from "./ModuleUIRenderer";

type PropsModule = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "Module"
>;

export const ModuleScreen = observer((props: PropsModule) => {
  const { route } = props;
  const planUid = route.params.planUid;
  const moduleUid = route.params.moduleUid;
  const dataUid = route.params.dataUid;

  const { plansApi, modulesApi, sectionsApi, businessPlansApi } = useApi();
  const { sessionStore, modulesStore, plansStore, sectionsStore } = useStores();

  useUserSelectForPlan(planUid);
  useLoadUsersInPlan(planUid);

  const [hasUpdatedVisit, setHasUpdatedVisit] = React.useState(false);

  const plan = plansStore.byId.get(planUid);
  const module = modulesStore.byId.get(moduleUid);
  const section = sectionsStore.byId.get(module?.data.sectionUid ?? "");

  React.useEffect(() => {
    async function loadData() {
      // TODO - need another place for this logic?
      if (!module) {
        const p = await plansApi.getById(planUid);
        await modulesApi.getById(moduleUid);
        if (p?.data.businessPlanUid) {
          await businessPlansApi.getById(p.data.businessPlanUid);
        }
      } else if (!section) {
        await sectionsApi.getById(module.data.sectionUid);
      }
    }

    void loadData();
  }, [
    module,
    section,
    sectionsApi,
    plansApi,
    modulesApi,
    businessPlansApi,
    planUid,
    moduleUid,
  ]);

  React.useEffect(() => {
    if (module && !hasUpdatedVisit && plan && plan.userInPlan) {
      plan.userInPlan?.updateVisitedTimestamp(module.uid);
      setHasUpdatedVisit(true);
    }
  }, [module, hasUpdatedVisit, plan]);

  if (
    !module ||
    !plan ||
    !plan.isUsersLoaded ||
    !sessionStore.isLoggedIn ||
    (plan.data.businessPlanUid && !plan.businessPlan)
  ) {
    return <FullScreenLoading subtitle={"Card loading..."} />;
  }

  return (
    <Screen theme={plan.businessPlan?.data.customerInfo.theme}>
      <ModuleUIRenderer uid={moduleUid} dataUid={dataUid} />
    </Screen>
  );
});

export default ModuleScreen;
